import { render, staticRenderFns } from "./ScrollParallax.vue?vue&type=template&id=3d98a4e7&scoped=true"
import script from "./ScrollParallax.vue?vue&type=script&lang=js"
export * from "./ScrollParallax.vue?vue&type=script&lang=js"
import style0 from "./ScrollParallax.vue?vue&type=style&index=0&id=3d98a4e7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d98a4e7",
  null
  
)

export default component.exports